import { StandardWalletAdapter } from '@solana/wallet-standard-wallet-adapter-base';
import { initializeWhenDetected as initializeMetaMaskWhenDetected } from '@solflare-wallet/metamask-wallet-standard';
import { SolflareWallet } from './wallet';
export class SolflareWalletAdapter extends StandardWalletAdapter {
    constructor({ disableMetaMask } = {}) {
        super({ wallet: new SolflareWallet() });
        if (!disableMetaMask) {
            initializeMetaMaskWhenDetected();
        }
    }
}
